'use es6';

import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import PropTypes from 'prop-types';
import createReactClass from 'create-react-class';
import { List, Map as ImmutableMap } from 'immutable';
import FormattedMessage from 'I18n/components/FormattedMessage';
import FormState from 'MeetingsLib/models/FormState';
import UIForm from 'UIComponents/form/UIForm';
import BookingFormField from './BookingFormField';
import FullNameInput from 'ui-addon-i18n/components/FullNameInput';
import CustomFormInputs from 'MeetingsLib/components/input/CustomFormInputs';
import RecaptchaField from './RecaptchaField';
export default createReactClass({
  displayName: "BookingFormFields",
  propTypes: {
    centerPropertyForm: PropTypes.bool,
    isLastStep: PropTypes.bool,
    disabled: PropTypes.bool,
    formFields: PropTypes.instanceOf(List).isRequired,
    formStateValidation: PropTypes.instanceOf(ImmutableMap).isRequired,
    formState: PropTypes.instanceOf(FormState),
    setFormValue: PropTypes.func.isRequired,
    recaptchaEnabled: PropTypes.bool.isRequired
  },
  renderField: function renderField(fieldName) {
    var _this$props = this.props,
        formStateValidation = _this$props.formStateValidation,
        formState = _this$props.formState,
        setFormValue = _this$props.setFormValue,
        disabled = _this$props.disabled;
    return /*#__PURE__*/_jsx(BookingFormField, {
      fieldName: fieldName,
      validation: formStateValidation.get(fieldName),
      fieldValue: formState.get(fieldName),
      isRequired: true,
      fieldLabel: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "prebook.details.field." + fieldName
      }),
      setFormValue: setFormValue,
      autocomplete: "on",
      disabled: disabled
    });
  },
  renderCustomFormFields: function renderCustomFormFields() {
    var _this$props2 = this.props,
        formFields = _this$props2.formFields,
        formStateValidation = _this$props2.formStateValidation,
        formState = _this$props2.formState,
        setFormValue = _this$props2.setFormValue,
        disabled = _this$props2.disabled;
    return /*#__PURE__*/_jsx(CustomFormInputs, {
      formFields: formFields,
      formStateValidation: formStateValidation.get('customFormFields'),
      customFormFields: formState.get('customFormFields'),
      onCustomFormFieldChange: setFormValue,
      disabled: disabled
    });
  },
  renderNameFields: function renderNameFields() {
    var disabled = this.props.disabled;
    return /*#__PURE__*/_jsx(FullNameInput, {
      direction: "row",
      wrap: "wrap",
      givenNameInput: this.renderField('firstName'),
      familyNameInput: this.renderField('lastName'),
      disabled: disabled
    });
  },
  renderRecaptcha: function renderRecaptcha() {
    var _this$props3 = this.props,
        recaptchaEnabled = _this$props3.recaptchaEnabled,
        isLastStep = _this$props3.isLastStep;

    if (recaptchaEnabled && isLastStep) {
      return /*#__PURE__*/_jsx(RecaptchaField, {});
    }

    return null;
  },
  render: function render() {
    var className = 'p-x-1 p-bottom-4' + (this.props.centerPropertyForm ? " p-x-15" : "");
    return /*#__PURE__*/_jsxs(UIForm, {
      className: className,
      children: [this.renderNameFields(), this.renderField('email'), this.renderCustomFormFields(), this.renderRecaptcha()]
    });
  }
});